export const itemStateEnum = [
  { id: 'ISSUED', label: 'Vydaný' },
  { id: 'IN_WAREHOUSE', label: 'Na skladě' },
  { id: 'LOST', label: 'Ztracený' },
  { id: 'STOLEN', label: 'Odcizený' },
  { id: 'DESTROYED', label: 'Zničený' },
  { id: 'UNDER_REPAIR', label: 'V opravě' },
  { id: 'AWAITING_CONFIRMATION', label: 'Čeká se na potvrzení' }
];



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/_operationalWarehouseEnums.ts